module.exports = __webpack_public_path__ + "static/media/ZeroButton.898207f1.svg";